/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  HTTPValidationError,
  ListProvenTaskFilesApiProvenTasksFilesGetParams,
  ProvenTaskFiles,
  ProvenTasksResponse,
  ReadProvenTaskFileApiProvenTasksFileGetParams,
  ReadRefineryTreeApiProvenTasksTreeGetParams,
  RefineryBenchmarksResponse,
  RefineryExclusionsResponse,
  RefineryExclusionsUpdate,
  RefineryRegenerateRequest,
  RefineryRegenerateResponse,
  RefineryTreeResponse,
  RegenerateTestsApiProvenTasksRegeneratePostParams,
  TrainingAgentFile,
} from "../model";

import { orvalFetch } from "../../client.ts";
import type { ErrorType } from "../../client.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listProvenTasksApiProvenTasksGetResponse200 = {
  data: ProvenTasksResponse;
  status: 200;
};

export type listProvenTasksApiProvenTasksGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listProvenTasksApiProvenTasksGetResponseSuccess =
  listProvenTasksApiProvenTasksGetResponse200 & {
    headers: Headers;
  };
export type listProvenTasksApiProvenTasksGetResponseError =
  listProvenTasksApiProvenTasksGetResponse422 & {
    headers: Headers;
  };

export type listProvenTasksApiProvenTasksGetResponse =
  | listProvenTasksApiProvenTasksGetResponseSuccess
  | listProvenTasksApiProvenTasksGetResponseError;

export const getListProvenTasksApiProvenTasksGetUrl = () => {
  return `/api/proven-tasks`;
};

/**
 * Every task the gate proves today for the team, newest batch first.
 * @summary List Proven Tasks
 */
export const listProvenTasksApiProvenTasksGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listProvenTasksApiProvenTasksGetResponse> => {
  return orvalFetch<listProvenTasksApiProvenTasksGetResponse>(
    getListProvenTasksApiProvenTasksGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListProvenTasksApiProvenTasksGetQueryKey = () => {
  return [`/api/proven-tasks`] as const;
};

export const getListProvenTasksApiProvenTasksGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof orvalFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListProvenTasksApiProvenTasksGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>
  > = ({ signal }) =>
    listProvenTasksApiProvenTasksGet({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListProvenTasksApiProvenTasksGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>
>;
export type ListProvenTasksApiProvenTasksGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListProvenTasksApiProvenTasksGet<
  TData = Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
          TError,
          Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProvenTasksApiProvenTasksGet<
  TData = Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
          TError,
          Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProvenTasksApiProvenTasksGet<
  TData = Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Proven Tasks
 */

export function useListProvenTasksApiProvenTasksGet<
  TData = Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTasksApiProvenTasksGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListProvenTasksApiProvenTasksGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type listRefineryBenchmarksApiProvenTasksBenchmarksGetResponse200 = {
  data: RefineryBenchmarksResponse;
  status: 200;
};

export type listRefineryBenchmarksApiProvenTasksBenchmarksGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listRefineryBenchmarksApiProvenTasksBenchmarksGetResponseSuccess =
  listRefineryBenchmarksApiProvenTasksBenchmarksGetResponse200 & {
    headers: Headers;
  };
export type listRefineryBenchmarksApiProvenTasksBenchmarksGetResponseError =
  listRefineryBenchmarksApiProvenTasksBenchmarksGetResponse422 & {
    headers: Headers;
  };

export type listRefineryBenchmarksApiProvenTasksBenchmarksGetResponse =
  | listRefineryBenchmarksApiProvenTasksBenchmarksGetResponseSuccess
  | listRefineryBenchmarksApiProvenTasksBenchmarksGetResponseError;

export const getListRefineryBenchmarksApiProvenTasksBenchmarksGetUrl = () => {
  return `/api/proven-tasks/benchmarks`;
};

/**
 * The benchmarks the team's evals config names, which the page can
 * show a tree for. The Data refinery page is the one caller and asks
 * once per visit, so this read is the page's visit in the audit log
 * (`refinery.view`, TRA-1626); a tree read is recorded on its own.
 * @summary List Refinery Benchmarks
 */
export const listRefineryBenchmarksApiProvenTasksBenchmarksGet = async (
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listRefineryBenchmarksApiProvenTasksBenchmarksGetResponse> => {
  return orvalFetch<listRefineryBenchmarksApiProvenTasksBenchmarksGetResponse>(
    getListRefineryBenchmarksApiProvenTasksBenchmarksGetUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListRefineryBenchmarksApiProvenTasksBenchmarksGetQueryKey =
  () => {
    return [`/api/proven-tasks/benchmarks`] as const;
  };

export const getListRefineryBenchmarksApiProvenTasksBenchmarksGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
    >,
    TError = ErrorType<HTTPValidationError>,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListRefineryBenchmarksApiProvenTasksBenchmarksGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
      >
    > = ({ signal }) =>
      listRefineryBenchmarksApiProvenTasksBenchmarksGet({
        signal,
        ...requestOptions,
      });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type ListRefineryBenchmarksApiProvenTasksBenchmarksGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
    >
  >;
export type ListRefineryBenchmarksApiProvenTasksBenchmarksGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListRefineryBenchmarksApiProvenTasksBenchmarksGet<
  TData = Awaited<
    ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRefineryBenchmarksApiProvenTasksBenchmarksGet<
  TData = Awaited<
    ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListRefineryBenchmarksApiProvenTasksBenchmarksGet<
  TData = Awaited<
    ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Refinery Benchmarks
 */

export function useListRefineryBenchmarksApiProvenTasksBenchmarksGet<
  TData = Awaited<
    ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
  >,
  TError = ErrorType<HTTPValidationError>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listRefineryBenchmarksApiProvenTasksBenchmarksGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getListRefineryBenchmarksApiProvenTasksBenchmarksGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type readRefineryTreeApiProvenTasksTreeGetResponse200 = {
  data: RefineryTreeResponse;
  status: 200;
};

export type readRefineryTreeApiProvenTasksTreeGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type readRefineryTreeApiProvenTasksTreeGetResponseSuccess =
  readRefineryTreeApiProvenTasksTreeGetResponse200 & {
    headers: Headers;
  };
export type readRefineryTreeApiProvenTasksTreeGetResponseError =
  readRefineryTreeApiProvenTasksTreeGetResponse422 & {
    headers: Headers;
  };

export type readRefineryTreeApiProvenTasksTreeGetResponse =
  | readRefineryTreeApiProvenTasksTreeGetResponseSuccess
  | readRefineryTreeApiProvenTasksTreeGetResponseError;

export const getReadRefineryTreeApiProvenTasksTreeGetUrl = (
  params: ReadRefineryTreeApiProvenTasksTreeGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/proven-tasks/tree?${stringifiedParams}`
    : `/api/proven-tasks/tree`;
};

/**
 * One benchmark's tree: the latest scoring night's tests, each with
 * the proven tasks generated from it. The tests are the team's own
 * code by path, so the read is recorded in the audit log (TRA-1626).
 * @summary Read Refinery Tree
 */
export const readRefineryTreeApiProvenTasksTreeGet = async (
  params: ReadRefineryTreeApiProvenTasksTreeGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<readRefineryTreeApiProvenTasksTreeGetResponse> => {
  return orvalFetch<readRefineryTreeApiProvenTasksTreeGetResponse>(
    getReadRefineryTreeApiProvenTasksTreeGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getReadRefineryTreeApiProvenTasksTreeGetQueryKey = (
  params?: ReadRefineryTreeApiProvenTasksTreeGetParams,
) => {
  return [`/api/proven-tasks/tree`, ...(params ? [params] : [])] as const;
};

export const getReadRefineryTreeApiProvenTasksTreeGetQueryOptions = <
  TData = Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadRefineryTreeApiProvenTasksTreeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReadRefineryTreeApiProvenTasksTreeGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>
  > = ({ signal }) =>
    readRefineryTreeApiProvenTasksTreeGet(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReadRefineryTreeApiProvenTasksTreeGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>
>;
export type ReadRefineryTreeApiProvenTasksTreeGetQueryError =
  ErrorType<HTTPValidationError>;

export function useReadRefineryTreeApiProvenTasksTreeGet<
  TData = Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadRefineryTreeApiProvenTasksTreeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
          TError,
          Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadRefineryTreeApiProvenTasksTreeGet<
  TData = Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadRefineryTreeApiProvenTasksTreeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
          TError,
          Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadRefineryTreeApiProvenTasksTreeGet<
  TData = Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadRefineryTreeApiProvenTasksTreeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Read Refinery Tree
 */

export function useReadRefineryTreeApiProvenTasksTreeGet<
  TData = Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadRefineryTreeApiProvenTasksTreeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readRefineryTreeApiProvenTasksTreeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReadRefineryTreeApiProvenTasksTreeGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type regenerateTestsApiProvenTasksRegeneratePostResponse200 = {
  data: RefineryRegenerateResponse;
  status: 200;
};

export type regenerateTestsApiProvenTasksRegeneratePostResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type regenerateTestsApiProvenTasksRegeneratePostResponseSuccess =
  regenerateTestsApiProvenTasksRegeneratePostResponse200 & {
    headers: Headers;
  };
export type regenerateTestsApiProvenTasksRegeneratePostResponseError =
  regenerateTestsApiProvenTasksRegeneratePostResponse422 & {
    headers: Headers;
  };

export type regenerateTestsApiProvenTasksRegeneratePostResponse =
  | regenerateTestsApiProvenTasksRegeneratePostResponseSuccess
  | regenerateTestsApiProvenTasksRegeneratePostResponseError;

export const getRegenerateTestsApiProvenTasksRegeneratePostUrl = (
  params: RegenerateTestsApiProvenTasksRegeneratePostParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/proven-tasks/regenerate?${stringifiedParams}`
    : `/api/proven-tasks/regenerate`;
};

/**
 * Staff-only: ask the next generation start to plan tests of the
 * scored benchmark again, `cards` each or at their tiers' counts. The
 * benchmark is the one the page shows, which must be the scored one.
 * @summary Regenerate Tests
 */
export const regenerateTestsApiProvenTasksRegeneratePost = async (
  refineryRegenerateRequest: RefineryRegenerateRequest,
  params: RegenerateTestsApiProvenTasksRegeneratePostParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<regenerateTestsApiProvenTasksRegeneratePostResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<regenerateTestsApiProvenTasksRegeneratePostResponse>(
    getRegenerateTestsApiProvenTasksRegeneratePostUrl(params),
    {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(refineryRegenerateRequest),
    },
  );
};

export const getRegenerateTestsApiProvenTasksRegeneratePostMutationKey = () =>
  ["regenerateTestsApiProvenTasksRegeneratePost"] as const;

export const getRegenerateTestsApiProvenTasksRegeneratePostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateTestsApiProvenTasksRegeneratePost>>,
    TError,
    RegenerateTestsApiProvenTasksRegeneratePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateTestsApiProvenTasksRegeneratePost>>,
  TError,
  RegenerateTestsApiProvenTasksRegeneratePostMutationVariables,
  TContext
> => {
  const mutationKey =
    getRegenerateTestsApiProvenTasksRegeneratePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateTestsApiProvenTasksRegeneratePost>>,
    RegenerateTestsApiProvenTasksRegeneratePostMutationVariables
  > = (props) => {
    const { data, params } = props ?? {};

    return regenerateTestsApiProvenTasksRegeneratePost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateTestsApiProvenTasksRegeneratePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof regenerateTestsApiProvenTasksRegeneratePost>>
  >;
export type RegenerateTestsApiProvenTasksRegeneratePostMutationBody =
  RefineryRegenerateRequest;
export type RegenerateTestsApiProvenTasksRegeneratePostMutationError =
  ErrorType<HTTPValidationError>;
export type RegenerateTestsApiProvenTasksRegeneratePostMutationVariables = {
  data: RefineryRegenerateRequest;
  params: RegenerateTestsApiProvenTasksRegeneratePostParams;
};

/**
 * @summary Regenerate Tests
 */
export const useRegenerateTestsApiProvenTasksRegeneratePost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateTestsApiProvenTasksRegeneratePost>>,
      TError,
      RegenerateTestsApiProvenTasksRegeneratePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateTestsApiProvenTasksRegeneratePost>>,
  TError,
  RegenerateTestsApiProvenTasksRegeneratePostMutationVariables,
  TContext
> => {
  return useMutation(
    getRegenerateTestsApiProvenTasksRegeneratePostMutationOptions(options),
    queryClient,
  );
};
export type saveExclusionsApiProvenTasksExclusionsPutResponse200 = {
  data: RefineryExclusionsResponse;
  status: 200;
};

export type saveExclusionsApiProvenTasksExclusionsPutResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type saveExclusionsApiProvenTasksExclusionsPutResponseSuccess =
  saveExclusionsApiProvenTasksExclusionsPutResponse200 & {
    headers: Headers;
  };
export type saveExclusionsApiProvenTasksExclusionsPutResponseError =
  saveExclusionsApiProvenTasksExclusionsPutResponse422 & {
    headers: Headers;
  };

export type saveExclusionsApiProvenTasksExclusionsPutResponse =
  | saveExclusionsApiProvenTasksExclusionsPutResponseSuccess
  | saveExclusionsApiProvenTasksExclusionsPutResponseError;

export const getSaveExclusionsApiProvenTasksExclusionsPutUrl = () => {
  return `/api/proven-tasks/exclusions`;
};

/**
 * Staff-only: keep proven tasks out of every dataset build, or let the
 * builds train on them again. Every other exclusion stays as it was.
 * @summary Save Exclusions
 */
export const saveExclusionsApiProvenTasksExclusionsPut = async (
  refineryExclusionsUpdate: RefineryExclusionsUpdate,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<saveExclusionsApiProvenTasksExclusionsPutResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit["headers"]>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(
          h as Iterable<Iterable<string>>,
          (entry) => Array.from(entry) as [string, string],
        ),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<
      string | readonly string[] | undefined
    >(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return orvalFetch<saveExclusionsApiProvenTasksExclusionsPutResponse>(
    getSaveExclusionsApiProvenTasksExclusionsPutUrl(),
    {
      ...options,
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        ...getHeaders(options?.headers),
      },
      body: JSON.stringify(refineryExclusionsUpdate),
    },
  );
};

export const getSaveExclusionsApiProvenTasksExclusionsPutMutationKey = () =>
  ["saveExclusionsApiProvenTasksExclusionsPut"] as const;

export const getSaveExclusionsApiProvenTasksExclusionsPutMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveExclusionsApiProvenTasksExclusionsPut>>,
    TError,
    SaveExclusionsApiProvenTasksExclusionsPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof orvalFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveExclusionsApiProvenTasksExclusionsPut>>,
  TError,
  SaveExclusionsApiProvenTasksExclusionsPutMutationVariables,
  TContext
> => {
  const mutationKey = getSaveExclusionsApiProvenTasksExclusionsPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveExclusionsApiProvenTasksExclusionsPut>>,
    SaveExclusionsApiProvenTasksExclusionsPutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return saveExclusionsApiProvenTasksExclusionsPut(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveExclusionsApiProvenTasksExclusionsPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof saveExclusionsApiProvenTasksExclusionsPut>>
  >;
export type SaveExclusionsApiProvenTasksExclusionsPutMutationBody =
  RefineryExclusionsUpdate;
export type SaveExclusionsApiProvenTasksExclusionsPutMutationError =
  ErrorType<HTTPValidationError>;
export type SaveExclusionsApiProvenTasksExclusionsPutMutationVariables = {
  data: RefineryExclusionsUpdate;
};

/**
 * @summary Save Exclusions
 */
export const useSaveExclusionsApiProvenTasksExclusionsPut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveExclusionsApiProvenTasksExclusionsPut>>,
      TError,
      SaveExclusionsApiProvenTasksExclusionsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveExclusionsApiProvenTasksExclusionsPut>>,
  TError,
  SaveExclusionsApiProvenTasksExclusionsPutMutationVariables,
  TContext
> => {
  return useMutation(
    getSaveExclusionsApiProvenTasksExclusionsPutMutationOptions(options),
    queryClient,
  );
};
export type listProvenTaskFilesApiProvenTasksFilesGetResponse200 = {
  data: ProvenTaskFiles;
  status: 200;
};

export type listProvenTaskFilesApiProvenTasksFilesGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listProvenTaskFilesApiProvenTasksFilesGetResponseSuccess =
  listProvenTaskFilesApiProvenTasksFilesGetResponse200 & {
    headers: Headers;
  };
export type listProvenTaskFilesApiProvenTasksFilesGetResponseError =
  listProvenTaskFilesApiProvenTasksFilesGetResponse422 & {
    headers: Headers;
  };

export type listProvenTaskFilesApiProvenTasksFilesGetResponse =
  | listProvenTaskFilesApiProvenTasksFilesGetResponseSuccess
  | listProvenTaskFilesApiProvenTasksFilesGetResponseError;

export const getListProvenTaskFilesApiProvenTasksFilesGetUrl = (
  params: ListProvenTaskFilesApiProvenTasksFilesGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/proven-tasks/files?${stringifiedParams}`
    : `/api/proven-tasks/files`;
};

/**
 * The files of one proven task's case; listing them is recorded in
 * the team's audit log (TRA-1626).
 * @summary List Proven Task Files
 */
export const listProvenTaskFilesApiProvenTasksFilesGet = async (
  params: ListProvenTaskFilesApiProvenTasksFilesGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<listProvenTaskFilesApiProvenTasksFilesGetResponse> => {
  return orvalFetch<listProvenTaskFilesApiProvenTasksFilesGetResponse>(
    getListProvenTaskFilesApiProvenTasksFilesGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListProvenTaskFilesApiProvenTasksFilesGetQueryKey = (
  params?: ListProvenTaskFilesApiProvenTasksFilesGetParams,
) => {
  return [`/api/proven-tasks/files`, ...(params ? [params] : [])] as const;
};

export const getListProvenTaskFilesApiProvenTasksFilesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ListProvenTaskFilesApiProvenTasksFilesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListProvenTaskFilesApiProvenTasksFilesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>
  > = ({ signal }) =>
    listProvenTaskFilesApiProvenTasksFilesGet(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListProvenTaskFilesApiProvenTasksFilesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>
>;
export type ListProvenTaskFilesApiProvenTasksFilesGetQueryError =
  ErrorType<HTTPValidationError>;

export function useListProvenTaskFilesApiProvenTasksFilesGet<
  TData = Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ListProvenTaskFilesApiProvenTasksFilesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
          TError,
          Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProvenTaskFilesApiProvenTasksFilesGet<
  TData = Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ListProvenTaskFilesApiProvenTasksFilesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
          TError,
          Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListProvenTaskFilesApiProvenTasksFilesGet<
  TData = Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ListProvenTaskFilesApiProvenTasksFilesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Proven Task Files
 */

export function useListProvenTaskFilesApiProvenTasksFilesGet<
  TData = Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ListProvenTaskFilesApiProvenTasksFilesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listProvenTaskFilesApiProvenTasksFilesGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListProvenTaskFilesApiProvenTasksFilesGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type readProvenTaskFileApiProvenTasksFileGetResponse200 = {
  data: TrainingAgentFile;
  status: 200;
};

export type readProvenTaskFileApiProvenTasksFileGetResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type readProvenTaskFileApiProvenTasksFileGetResponseSuccess =
  readProvenTaskFileApiProvenTasksFileGetResponse200 & {
    headers: Headers;
  };
export type readProvenTaskFileApiProvenTasksFileGetResponseError =
  readProvenTaskFileApiProvenTasksFileGetResponse422 & {
    headers: Headers;
  };

export type readProvenTaskFileApiProvenTasksFileGetResponse =
  | readProvenTaskFileApiProvenTasksFileGetResponseSuccess
  | readProvenTaskFileApiProvenTasksFileGetResponseError;

export const getReadProvenTaskFileApiProvenTasksFileGetUrl = (
  params: ReadProvenTaskFileApiProvenTasksFileGetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/proven-tasks/file?${stringifiedParams}`
    : `/api/proven-tasks/file`;
};

/**
 * One file of a proven task's case as text; opening it is recorded
 * in the team's audit log (TRA-1626), by path, never by content.
 * @summary Read Proven Task File
 */
export const readProvenTaskFileApiProvenTasksFileGet = async (
  params: ReadProvenTaskFileApiProvenTasksFileGetParams,
  options?: Parameters<typeof orvalFetch>[1],
): Promise<readProvenTaskFileApiProvenTasksFileGetResponse> => {
  return orvalFetch<readProvenTaskFileApiProvenTasksFileGetResponse>(
    getReadProvenTaskFileApiProvenTasksFileGetUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getReadProvenTaskFileApiProvenTasksFileGetQueryKey = (
  params?: ReadProvenTaskFileApiProvenTasksFileGetParams,
) => {
  return [`/api/proven-tasks/file`, ...(params ? [params] : [])] as const;
};

export const getReadProvenTaskFileApiProvenTasksFileGetQueryOptions = <
  TData = Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadProvenTaskFileApiProvenTasksFileGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getReadProvenTaskFileApiProvenTasksFileGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>
  > = ({ signal }) =>
    readProvenTaskFileApiProvenTasksFileGet(params, {
      signal,
      ...requestOptions,
    });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReadProvenTaskFileApiProvenTasksFileGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>
>;
export type ReadProvenTaskFileApiProvenTasksFileGetQueryError =
  ErrorType<HTTPValidationError>;

export function useReadProvenTaskFileApiProvenTasksFileGet<
  TData = Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadProvenTaskFileApiProvenTasksFileGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
          TError,
          Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadProvenTaskFileApiProvenTasksFileGet<
  TData = Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadProvenTaskFileApiProvenTasksFileGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
          TError,
          Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadProvenTaskFileApiProvenTasksFileGet<
  TData = Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadProvenTaskFileApiProvenTasksFileGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Read Proven Task File
 */

export function useReadProvenTaskFileApiProvenTasksFileGet<
  TData = Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: ReadProvenTaskFileApiProvenTasksFileGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof readProvenTaskFileApiProvenTasksFileGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof orvalFetch>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReadProvenTaskFileApiProvenTasksFileGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
